<template>
    <div class="mt-5" id="statistics-section">
        <div class="grid grid-cols-12 gap-3">
            <div class="col-span-12">
                <div class="grid grid-cols-12 gap-6">
                    <div class="col-span-12">
                        <div class="report-box-2 intro-y mt-2 h-full">
                            <div class="box sm:flex h-full">
                                <div class="p-5 flex-1 flex flex-col justify-center relative">
                                    <div class="grid grid-cols-12">
                                        <h3
                                            class="col-span-12 md:col-span-3 lg:col-span-5 xl:col-span-7 text-xl font-bold leading-none text-blue-custom">
                                            ครัวเรือนเปราะบาง
                                        </h3>
                                        <div class="col-span-12 md:col-span-9 lg:col-span-7 xl:col-span-5 mt-3 md:mt-0">
                                            <div
                                                class="relative sm:absolute right-0 sm:right-4 sm:top-4 pl-3 sm:pl-0 flex rounded-lg border border-gray-300 overflow-hidden">
                                                <fieldset class="flex-grow text-center">
                                                    <input class="peer" type="radio" checked="0" name="name"
                                                        id="firstOptionId" value="1" v-model="selectProvinceChartState">
                                                    <label
                                                        class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-2 peer-checked:text-white select-none"
                                                        for="firstOptionId">เรียงตามตัวอักษร</label>
                                                </fieldset>
                                                <fieldset class="flex-grow text-center border-l border-gray-300">
                                                    <input class="peer" type="radio" checked="checked" name="name"
                                                        id="secondOptionId" value="2"
                                                        v-model="selectProvinceChartState">
                                                    <label
                                                        class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-2 peer-checked:text-white select-none"
                                                        for="secondOptionId">เรียงตามจำนวนครัวเรือน</label>
                                                </fieldset>
                                            </div>
                                            <h3
                                                class="text-md mt-3 sm:mt-0 font-bold leading-none text-light-blue-custom">
                                                จำนวนครัวเรือนเปราะบาง
                                            </h3>
                                            <h3 class="text-lg font-normal mt-3 leading-none text-pink-custom"
                                                v-if="this.fragileStackBarChartProvince != null">
                                                {{
                                                this.globalNumDecFixed(this.fragileStackBarChartProvince.total.fg0 +
                                                this.fragileStackBarChartProvince.total.fg1 +
                                                this.fragileStackBarChartProvince.total.fg2 +
                                                this.fragileStackBarChartProvince.total.fg3)
                                                }}
                                                ครัวเรือน
                                            </h3>
                                            <h3 class="text-lg font-normal mt-3 leading-none text-pink-custom" v-else>
                                                ... ครัวเรือน
                                            </h3>
                                            <div class="p-2 rounded mt-3 grid grid-cols-2 gap-x-6"
                                                style="background-color: #f3f6f9; font-size: .75rem; color: #728196">
                                                <!-- <div v-for="index in 4" :key="index"> -->
                                                <div class="col-span-2 md:col-span-1">
                                                    <div class="grid grid-cols-2">
                                                        <div class="t-tooltip cursor-pointer">
                                                            <span class="t-tooltip-text"
                                                                style="width: 200px;margin-left: -50px">
                                                                เปราะบางระดับ 0 :
                                                                ครัวเรือนที่ไม่ตกมิติด้านรายได้และมีบุคคลที่มีภาวะพึ่งพิง
                                                            </span>
                                                            <font-awesome-icon :icon="['fas', 'circle']"
                                                                style="color: #7bbae0" />
                                                            &nbsp;เปราะบางระดับ 0
                                                        </div>
                                                        <p class="float-right"
                                                            v-if="this.fragileStackBarChartProvince != null">{{
                                                            this.globalNumDecFixed(this.fragileStackBarChartProvince.total.fg0)
                                                            }}
                                                            ครัวเรือน</p>
                                                        <p class="float-right" v-else>... ครัวเรือน</p>
                                                    </div>
                                                </div>

                                                <div class="col-span-2 md:col-span-1">
                                                    <div class="grid grid-cols-2">
                                                        <div class="t-tooltip cursor-pointer">
                                                            <span class="t-tooltip-text"
                                                                style="width: 200px;margin-left: -50px">
                                                                เปราะบางระดับ 2 : ครัวเรือนที่มีรายได้น้อย
                                                                และมีบุคคลที่อยู่ในภาวะพึ่งพิง จำนวน 1–2 คน

                                                            </span>
                                                            <font-awesome-icon :icon="['fas', 'circle']"
                                                                style="color: #e1dfa6" />
                                                            &nbsp;เปราะบางระดับ 2
                                                        </div>
                                                        <p class="float-right"
                                                            v-if="this.fragileStackBarChartProvince != null">{{
                                                            this.globalNumDecFixed(this.fragileStackBarChartProvince.total.fg2)
                                                            }}
                                                            ครัวเรือน</p>
                                                        <p class="float-right" v-else>... ครัวเรือน</p>
                                                    </div>
                                                </div>
                                                <div class="col-span-2 md:col-span-1">
                                                    <div class="grid grid-cols-2">
                                                        <div class="t-tooltip cursor-pointer">
                                                            <span class="t-tooltip-text"
                                                                style="width: 200px;margin-left: -50px">
                                                                เปราะบางระดับ 1 : ครัวเรือนที่มีรายได้น้อย
                                                                (รายได้เฉลี่ยต่อคนต่อปีไม่เกิน 100,000 บาท)
                                                            </span>
                                                            <font-awesome-icon :icon="['fas', 'circle']"
                                                                style="color: #dd9090" />
                                                            &nbsp;เปราะบางระดับ 1
                                                        </div>
                                                        <p class="float-right"
                                                            v-if="this.fragileStackBarChartProvince != null">{{
                                                            this.globalNumDecFixed(this.fragileStackBarChartProvince.total.fg1)
                                                            }}
                                                            ครัวเรือน</p>
                                                        <p class="float-right" v-else>... ครัวเรือน</p>
                                                    </div>
                                                </div>
                                                <div class="col-span-2 md:col-span-1">
                                                    <div class="grid grid-cols-2">
                                                        <div class="t-tooltip cursor-pointer">
                                                            <span class="t-tooltip-text"
                                                                style="width: 200px;margin-left: -50px">
                                                                เปราะบางระดับ 3 : ครัวเรือนที่มีรายได้น้อย
                                                                และมีบุคคลที่อยู่ในภาวะพึ่งพิง จำนวนมากกว่า 2 คน ขึ้นไป
                                                            </span>
                                                            <font-awesome-icon :icon="['fas', 'circle']"
                                                                style="color: #925050" />
                                                            &nbsp;เปราะบางระดับ 3
                                                        </div>
                                                        <p class="float-right"
                                                            v-if="this.fragileStackBarChartProvince != null">{{
                                                            this.globalNumDecFixed(this.fragileStackBarChartProvince.total.fg3)
                                                            }}
                                                            ครัวเรือน</p>
                                                        <p class="float-right" v-else>... ครัวเรือน</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- </div> -->
                                        </div>
                                    </div>

                                    <div style="min-height: 500px">
                                        <div>
                                            <StackProvinceHor id="stacked_77_prov_section"
                                                v-if="fragileStackBarChartProvinceState"
                                                :fragileStackBarChartProvince="fragileStackBarChartProvince.province_fg_list"
                                                :key="fragileStackBarChartProvinceKey" class="stacked_77_prov" />
                                        </div>
                                        <div class="relative w-full h-full" v-if="!fragileStackBarChartProvinceState && !fragileStackBarChartProvinceError">
                                            <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                                <LoadingIcon icon="three-dots" class="loading-icon" />
                                            </div>
                                        </div>
                                        <div class="relative w-full h-full" v-if="fragileStackBarChartProvinceError">
                                            <div class="absolute w-44 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                                <p class="text-grey2-custom text-center">ไม่สามารถเชื่อมข้อมูลได้</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- จำนวนสมาชิกในครอบครัวที่ประสบปัญหา -->
        <div class="grid grid-cols-6 gap-3 mt-5">
            <div class="col-span-6 lg:col-span-6 mt-3 report-box-2 intro-y">
                <div class="box sm:flex h-full">
                    <div class="px-4 py-4 flex-1 flex flex-col justify-center relative">
                        <div class="grid grid-cols-12">
                            <div class="col-span-12 md:col-span-6">
                                <h3 class="text-lg font-bold leading-none text-custom-member">
                                    จำนวนสมาชิกในครอบครัวที่ประสบปัญหา
                                </h3>

                                <p class="text-sm leading-none text-grey-custom mt-3" v-if="this.SumDimProblem != null">
                                    จากประชากร {{
                                    this.globalNumDecFixed(this.SumDimProblem.total_survey,
                                    0)
                                    }} คน</p>
                                <p class="text-sm leading-none text-grey-custom mt-3" v-else>จากประชากร ... คน</p>
                            </div>
                            <h3 class="text-pink-custom col-span-12 md:col-span-6 float-right text-right mb-0 text-3xl my-auto"
                                v-if="this.SumDimProblem != null">
                                {{
                                this.globalNumDecFixed(this.SumDimProblem.total_prob,
                                0)
                                }} คน
                            </h3>
                            <h3 class="text-pink-custom col-span-12 md:col-span-6 float-right text-right mb-0 text-3xl my-auto"
                                v-else>
                                ... คน
                            </h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-span-6 lg:col-span-6 rows-span-1 mt-3 report-box-2 intro-y">
                <div class="box sm:flex h-full">
                    <div class="px-4 py-4 flex-1 flex flex-col justify-center relative">
                        <h3 class="text-lg font-bold leading-none text-custom-member">
                            สภาพปัญหาของสมาชิกในครัวเรือน 9 ด้าน
                        </h3>
                        <div class="grid grid-cols-12">
                            <div class="col-span-12 md:col-span-4 lg:col-span-5 xl:col-span-4 grid">
                                <div class="card text-grey text-grey-custom place-self-center w-full"
                                    style="line-height: 1.5rem">
                                    <b>ปัญหาแยกรายด้าน</b>
                                    <table style="font-size: .8rem !important;">
                                        <thead>
                                            <tr class="w-100">
                                                <td style="width: 100%;"></td>
                                                <td style="width: auto;"></td>
                                                <td style="width: 10%;min-width: 25px; float: right;"></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #fa4770" />
                                                    &nbsp;ที่อยู่อาศัย
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_housing,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #a984fa" />
                                                    &nbsp;สุขภาพ
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_health,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #0080ff" />
                                                    &nbsp;การศึกษา
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_education,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #47c0c9" />
                                                    &nbsp;มีงานทำ/รายได้
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_occupation,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #adb95d" />
                                                    &nbsp;ครอบครัว
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_family,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #cdac7a" />
                                                    &nbsp;ความรุนแรง
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_violence,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #f4c70a" />
                                                    &nbsp;ค้ามนุษย์
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_human_trafficking,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #fb9382" />
                                                    &nbsp;การเข้าถึงสิทธิ
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_accessibility,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <font-awesome-icon :icon="['fas', 'circle']"
                                                        style="color: #f8a436" />
                                                    &nbsp;อื่นๆ
                                                </td>
                                                <td>
                                                    <p class="float-right" v-if="this.SumDimProblem != null">{{
                                                    this.globalNumDecFixed(this.SumDimProblem.prob_others,
                                                    0)
                                                    }}</p>
                                                    <p class="float-right" v-else>...</p>
                                                </td>
                                                <td style="float: right;">คน</td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-8 lg:col-span-7 xl:col-span-8 mt-3 lg:mt-0">
                                <RadiusPolarChart v-if="SumDimProblemState" :SumDimProblem="SumDimProblem" />
                                <div class="relative w-full h-full" v-if="!SumDimProblemState && !SumDimProblemError">
                                    <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                        <LoadingIcon icon="three-dots" class="loading-icon" />
                                    </div>
                                </div>
                                <div class="relative w-full h-full" v-if="SumDimProblemError">
                                    <div class="absolute w-44 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                        <p class="text-grey2-custom text-center">ไม่สามารถเชื่อมข้อมูลได้</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-span-6 lg:col-span-3 rows-span-3 mt-3 report-box-2 intro-y">
                <div class="box sm:flex h-full">
                    <div class="px-4 py-4 flex-1 flex flex-col justify-center relative">
                        <h3 class="text-lg font-bold leading-none text-custom-member">
                            สถานะการติดตามเพื่อแก้ไขปัญหา
                        </h3>
                        <div class="grid grid-cols-12">
                            <div class="col-span-12 md:col-span-5 grid">
                                <table class="table-auto mt-3 lg:mt-0 place-self-center w-full text-grey-custom"
                                    style="height: fit-content; font-size: .8rem">
                                    <th>
                                        <tr class="w-100">
                                            <td></td>
                                            <td style="width: auto;"></td>
                                        </tr>
                                    </th>
                                    <tbody>
                                        <tr>
                                            <td style="max-width: 20px;width: 20px">
                                                <font-awesome-icon :icon="['fas', 'circle']" style="color: #adb95d" />
                                            </td>
                                            <td>
                                                ช่วยเหลือแล้ว
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td class="text-left">
                                                <span class="text-blue-custom" v-if="this.probTracking != null">{{
                                                this.globalNumDecFixed(
                                                this.probTracking.helped / (this.sumProbTracking / 100))
                                                }} %</span>
                                                <span class="text-blue-custom" v-else>... %</span>

                                                <span class="" v-if="this.probTracking != null"> ({{
                                                this.globalNumDecFixed(
                                                this.probTracking.helped)
                                                }} คน)</span>
                                                <span v-else> (... คน)</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <font-awesome-icon :icon="['fas', 'circle']" style="color: #f4c730" />
                                            </td>
                                            <td>
                                                อยู่ระหว่างการช่วยเหลือ
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td class="text-left">
                                                <span class="text-blue-custom" v-if="this.probTracking != null">{{
                                                this.globalNumDecFixed(
                                                this.probTracking.in_process / (this.sumProbTracking /
                                                100))
                                                }} %</span>
                                                <span class="text-blue-custom" v-else>... %</span>

                                                <span class="" v-if="this.probTracking != null"> ({{
                                                this.globalNumDecFixed(
                                                this.probTracking.in_process)
                                                }} คน)</span>
                                                <span class="" v-else> (... คน)</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <font-awesome-icon :icon="['fas', 'circle']" style="color: #e2e8f0" />
                                            </td>
                                            <td>
                                                ยังไม่ได้ดำเนินการ
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td class="text-left">
                                                <span class="text-blue-custom" v-if="this.probTracking != null">{{
                                                this.globalNumDecFixed(
                                                this.probTracking.not_proceeded / (this.sumProbTracking
                                                /
                                                100))
                                                }} %</span>
                                                <span class="text-blue-custom" v-else>... %</span>
                                                <span class="" v-if="this.probTracking != null"> ({{
                                                this.globalNumDecFixed(
                                                this.probTracking.not_proceeded)
                                                }} คน)</span>
                                                <span class="" v-else> (... คน)</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-span-12 lg:col-span-7 mt-3 lg:mt-0">
                                <pieChart id="pieChart" v-if="probTrackingState" :probTracking="probTracking" />
                                <div class="relative w-full h-full" v-if="!probTrackingState && !probTrackingError">
                                    <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                        <LoadingIcon icon="three-dots" class="loading-icon" />
                                    </div>
                                </div>
                                <div class="relative w-full h-full" v-if="probTrackingError">
                                    <div class="absolute w-44 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                        <p class="text-grey2-custom text-center">ไม่สามารถเชื่อมข้อมูลได้</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-span-6 lg:col-span-3 rows-span-2 mt-3 report-box-2 intro-y">
                <div class="box sm:flex h-full">
                    <div class="px-4 py-4 flex-1 flex flex-col relative">
                        <h3 class="text-lg font-bold leading-none text-custom-member">
                            แนวทางการแก้ไขปัญหา
                        </h3>
                        <div class="grid grid-cols-12">
                            <div class="col-span-12 md:col-span-5 grid">
                                <table class="table-auto mt-3 lg:mt-0 place-self-center w-full text-grey-custom"
                                    style="height: fit-content; font-size: .8rem">
                                    <th>
                                        <tr class="w-100">
                                            <td></td>
                                            <td style="width: auto;"></td>
                                        </tr>
                                    </th>
                                    <tbody>
                                        <tr>
                                            <td style="max-width: 20px;width: 20px">
                                                <font-awesome-icon :icon="['fas', 'circle']" style="color: #7bbae0" />
                                            </td>
                                            <td>
                                                ให้คำแนะนำ
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td class="text-left">
                                                <span class="text-blue-custom" v-if="this.probSolution != null">{{
                                                this.globalNumDecFixed(
                                                this.probSolution.suggestion / (this.sumProbSolution /
                                                100))
                                                }} %</span>
                                                <span class="text-blue-custom" v-else>... %</span>
                                                <span v-if="this.probSolution != null"> ({{ this.globalNumDecFixed(
                                                this.probSolution.suggestion)
                                                }} แผน)</span>
                                                <span v-else> (... แผน)</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <font-awesome-icon :icon="['fas', 'circle']" style="color: #cdac7a" />
                                            </td>
                                            <td>
                                                ช่วยเหลือโดย พม.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td class="text-left">
                                                <span class="text-blue-custom" v-if="this.probSolution != null">{{
                                                this.globalNumDecFixed(
                                                this.probSolution.assistance / (this.sumProbSolution /
                                                100))
                                                }} %</span>
                                                <span class="text-blue-custom" v-else>... %</span>
                                                <span class="" v-if="this.probSolution != null"> ({{
                                                this.globalNumDecFixed(
                                                this.probSolution.assistance)
                                                }} แผน)</span>
                                                <span class="" v-else> (... แผน)</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <font-awesome-icon :icon="['fas', 'circle']" style="color: #e1dfa6" />
                                            </td>
                                            <td>
                                                ประสานส่งต่อหน่วยงานอื่น
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td class="text-left">
                                                <span class="text-blue-custom" v-if="this.probSolution != null">{{
                                                this.globalNumDecFixed(
                                                this.probSolution.transfer / (this.sumProbSolution /
                                                100))
                                                }} %</span>
                                                <span class="text-blue-custom" v-else>... %</span>
                                                <span class="" v-if="this.probSolution != null"> ({{
                                                this.globalNumDecFixed(
                                                this.probSolution.transfer)
                                                }} แผน)</span>
                                                <span class="" v-else> (... แผน)</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="col-span-12 lg:col-span-7 mt-3 lg:mt-0">
                                <doughnutChart id="doughnutChart" v-if="probSolutionState"
                                    :probSolution="probSolution" />
                                <div class="relative w-full h-full" v-if="!probSolutionState && !probSolutionError">
                                    <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                        <LoadingIcon icon="three-dots" class="loading-icon" />
                                    </div>
                                </div>
                                <div class="relative w-full h-full" v-if="probSolutionError">
                                    <div class="absolute w-44 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                                        <p class="text-grey2-custom text-center">ไม่สามารถเชื่อมข้อมูลได้</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Import chart component
import StackProvinceHor from '@/components/echart/landing/stackProvinceHor.vue'
import RadiusPolarChart from '@/components/echart/landing/radiusPolarChart9Sides.vue'
import pieChart from '@/components/echart/landing/pieChartFollowFixProblem.vue'
import doughnutChart from '@/components/echart/landing/doughnutChartHowToFix.vue'

import axios from "axios"

import { useStore } from "@/store";
const store = useStore();

import { computed, defineComponent, reactive, ref, watch } from 'vue'
const headers = {
    "Content-Type": `application/json; charset=utf-8`,
    "Cache-Control": 'max-age=3600'
};

// import searchDropdown from "../container/searchDropdown.vue"
export default defineComponent({
    data() {
        return {
            fragileStackBarChartProvince: null,
            fragileStackBarChartProvinceState: false,
            fragileStackBarChartProvinceError: false,
            fragileStackBarChartProvinceKey: 0,
            SumDimProblem: null,
            SumDimProblemState: false,
            SumDimProblemError: false,
            probTracking: null,
            probTrackingState: false,
            probTrackingError: false,
            sumProbTracking: 0,
            probSolution: null,
            probSolutionState: false,
            probSolutionError: false,
            sumProbSolution: 0,
            selectProvinceChartState: 2
        }
    },
    components: {
        StackProvinceHor,
        RadiusPolarChart,
        pieChart,
        doughnutChart
    },
    setup() {

    },
    mounted() {
        // แก้ปัญหา font ไม่ load ในตอนเข้าหน้ามา ต้องเอาเมาส์วางก่อนทีนึง
        setTimeout(() => {
            if (this.probTrackingState == true)
                document.getElementById('pieChart').dispatchEvent(new MouseEvent('mouseover', { 'bubbles': true }));
            if (this.probSolutionState == true) {
                document.getElementById('doughnutChart').dispatchEvent(new MouseEvent('mouseover', { 'bubbles': true }));
            }
        }, 750)
    },
    methods: {
        compareProvinceFG(a, b) {
            const a_total = a.fg0 + a.fg1 + a.fg2 + a.fg3;
            const b_total = b.fg0 + b.fg1 + b.fg2 + b.fg3;
            if (a_total < b_total) {
                return 1;
            }
            if (a_total > b_total) {
                return -1;
            }
            return 0;
        },
        compareProvinceName(a, b) {
            console.log(a);
            console.log(a.province_name);
            var a_name = '', b_name = '', test = 0;
            if (a.village_name) {
                a_name = a.village_name;
                b_name = b.village_name;
                test = 1;
            } else if (a.tumbol_name) {
                a_name = a.tumbol_name;
                b_name = b.tumbol_name;
                test = 2;
            } else if (a.amphur_name) {
                a_name = a.amphur_name;
                b_name = b.amphur_name;
                test = 3;
            } else {
                a_name = a.province_name;
                b_name = b.province_name;
                test = 4;
            }
            console.log('compare : ' + test);

            if (a_name == null || b_name == null) {
                return -1;
            } else if (a_name.localeCompare(b_name, 'th') == -1) {
                return -1;
            } else if (a_name.localeCompare(b_name, 'th') == 1) {
                return 1;
            }
            return 0;
        },
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            if (!(num % 1)) {
                dec_amount = 0;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        },
        millionShortNum(num) {
            if (num >= 1000000000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    2
                );
            }
            if (num >= 1000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    2
                );
            }
            if (num >= 1000000000000) {
                return this.globalNumDecFixed((num / 1000000000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 2);
            }
            if (num >= 1000000) {
                return this.globalNumDecFixed((num / 1000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 2);
            }
            return this.globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
        },
        millionShortString(num) {
            if (num >= 1000000000000000000000000) {
                return "ล้านล้านล้านล้าน";
            }
            if (num >= 1000000000000000000) {
                return "ล้านล้านล้าน";
            }
            if (num >= 1000000000000) {
                return "ล้านล้าน";
            }
            if (num >= 1000000) {
                return "ล้าน";
            }
            return '';
        },
        getParams() {
            var params = {};
            if (store.state.mainFilterSearch.provID && store.state.mainFilterSearch.provID != 0) {
                params.prov = (store.state.mainFilterSearch.provID).toString();
            }
            if (store.state.mainFilterSearch.ampID && store.state.mainFilterSearch.ampID != 0) {
                params.amp = (store.state.mainFilterSearch.ampID).toString();
            }
            if (store.state.mainFilterSearch.tambolID && store.state.mainFilterSearch.tambolID != 0) {
                params.tam = (store.state.mainFilterSearch.tambolID).toString();
            }
            if (store.state.mainFilterSearch.osm && store.state.mainFilterSearch.osm != 0) {
                params.osm = (store.state.mainFilterSearch.osm).toString();
            }

            var fragilePickedArray = [...store.state.main.fragilePicked];
            var probPickedArray = [...store.state.main.probPicked];
            if (fragilePickedArray.includes('0')) {
                params.fg0 = 1;
            }
            if (fragilePickedArray.includes('1')) {
                params.fg1 = 1;
            }
            if (fragilePickedArray.includes('2')) {
                params.fg2 = 1;
            }
            if (fragilePickedArray.includes('3')) {
                params.fg3 = 1;
            }
            if (probPickedArray.includes('0')) {
                params.prob_housing = 1;
            }
            if (probPickedArray.includes('1')) {
                params.prob_health = 1;
            }
            if (probPickedArray.includes('2')) {
                params.prob_education = 1;
            }
            if (probPickedArray.includes('3')) {
                params.prob_occupation = 1;
            }
            if (probPickedArray.includes('4')) {
                params.prob_family = 1;
            }
            if (probPickedArray.includes('5')) {
                params.prob_violence = 1;
            }
            if (probPickedArray.includes('6')) {
                params.prob_human_trafficking = 1;
            }
            if (probPickedArray.includes('7')) {
                params.prob_accessibility = 1;
            }
            if (probPickedArray.includes('8')) {
                params.prob_others = 1;
            }

            return params;
        },
        async initialBarChartProvHor() {
            this.fragileStackBarChartProvinceState = false;
            this.fragileStackBarChartProvinceError = false;
            this.fragileStackBarChartProvince = null;
            var params = this.getParams();
            await axios.post(`${process.env.VUE_APP_BASE_API}member/getFragileAreaStats`,
                params,
                {headers}
            ).then((response) => {
                if (response.status === 200) {
                    var data = response.data;
                    console.log('Load Data Province Hor success !!');
                    this.fragileStackBarChartProvince = data;
                    this.fragileStackBarChartProvinceState = true;

                    // Force sort by name 1 time
                    var fragileStackBarChartProvinceDup = this.fragileStackBarChartProvince.province_fg_list
                    fragileStackBarChartProvinceDup.sort(this.compareProvinceFG);
                    this.fragileStackBarChartProvinceKey++;
                } else {
                    this.fragileStackBarChartProvinceError = true;
                    console.log(response.status.statusText);
                }
            }).catch((error) => {
                var message = error.response.data.message;
                this.fragileStackBarChartProvinceError = true;
                console.log(message);
            });
        },
        async initialRadialSumDimProb() {
            this.SumDimProblemState = false;
            this.SumDimProblemError = false;
            this.SumDimProblem = null;
            var params = this.getParams();

            await axios.post(`${process.env.VUE_APP_BASE_API}member/getProblemStats`,
                params,
                {headers}
            ).then((response) => {
                if (response.status === 200) {
                    var data = response.data;
                    console.log('Load Data SumDimProblem success !!');
                    this.SumDimProblem = data;
                    // this.SumDimProblem = SumDimProblem.prob_housing + SumDimProblem.prob_health + SumDimProblem.prob_education + SumDimProblem.prob_occupation + SumDimProblem.prob_family + SumDimProblem.prob_violence + SumDimProblem.prob_human_trafficking+ SumDimProblem.prob_accessibility+ SumDimProblem.prob_others;
                    this.SumDimProblemState = true;
                } else {
                    this.SumDimProblemError = true;
                    console.log(response.status.statusText);
                }
            }).catch((error) => {
                var message = error.response.data.message;
                this.SumDimProblemError = true;
                console.log(message);
            });
        },
        async initialPieProbTracking() {
            this.probTrackingState = false;
            this.probTrackingError = false;
            this.probTracking = null;
            var params = this.getParams();

            await axios.post(`${process.env.VUE_APP_BASE_API}member/getOperationStats`,
                params,
                {headers}
            ).then((response) => {
                if (response.status === 200) {
                    var data = response.data;
                    console.log('Load Data ProbTracking success !!');
                    this.probTracking = data;
                    this.sumProbTracking = this.probTracking.helped + this.probTracking.in_process + this.probTracking.not_proceeded;
                    this.probTrackingState = true;
                } else {
                    this.probTrackingError = true;
                    console.log(response.status.statusText);
                }
            }).catch((error) => {
                var message = error.response.data.message;
                this.probTrackingError = true;
                console.log(message);
            });
        },
        async initialDouhgnutProbSolution() {
            this.probSolutionState = false;
            this.probSolutionError = false;
            this.probSolution = null;
            var params = this.getParams();

            await axios.post(`${process.env.VUE_APP_BASE_API}member/getAidDirectionStats`,
                params,
                {headers}
            ).then((response) => {
                if (response.status === 200) {
                    var data = response.data;
                    console.log('Load Data ProbSolution success !!');
                    this.probSolution = data;
                    this.sumProbSolution = this.probSolution.suggestion + this.probSolution.assistance + this.probSolution.transfer;
                    this.probSolutionState = true;
                } else {
                    this.probSolutionError = true;
                    console.log(response.status.statusText);
                }
            }).catch((error) => {
                var message = error.response.data.message;
                this.probSolutionError = true;
                console.log(message);
            });
        }
    },
    created() {
        this.initialBarChartProvHor();
        this.initialDouhgnutProbSolution();
        this.initialRadialSumDimProb();
        this.initialPieProbTracking();
    },
    watch: {
        selectProvinceChartState(newValue) {
            if (newValue == 1) {
                var fragileStackBarChartProvinceDup = this.fragileStackBarChartProvince.province_fg_list
                fragileStackBarChartProvinceDup.sort(this.compareProvinceName);
                this.fragileStackBarChartProvinceKey++;
            } else {
                var fragileStackBarChartProvinceDup = this.fragileStackBarChartProvince.province_fg_list
                fragileStackBarChartProvinceDup.sort(this.compareProvinceFG);
                this.fragileStackBarChartProvinceKey++;
            }
        },
        '$store.state.mainFilterSearch.provID': function () {
            this.initialBarChartProvHor();
            this.initialDouhgnutProbSolution();
            this.initialRadialSumDimProb();
            this.initialPieProbTracking();
        },
        '$store.state.mainFilterSearch.ampID': function () {
            this.initialBarChartProvHor();
            this.initialDouhgnutProbSolution();
            this.initialRadialSumDimProb();
            this.initialPieProbTracking();
        },
        '$store.state.mainFilterSearch.tambolID': function () {
            this.initialBarChartProvHor();
            this.initialDouhgnutProbSolution();
            this.initialRadialSumDimProb();
            this.initialPieProbTracking();
        },
        '$store.state.main.fragilePicked': function () {
            this.initialBarChartProvHor();
            this.initialDouhgnutProbSolution();
            this.initialRadialSumDimProb();
            this.initialPieProbTracking();
        },
        '$store.state.main.probPicked': function () {
            this.initialBarChartProvHor();
            this.initialDouhgnutProbSolution();
            this.initialRadialSumDimProb();
            this.initialPieProbTracking();
        },
        '$store.state.mainFilterSearch.osm': function () {
            this.initialBarChartProvHor();
            this.initialDouhgnutProbSolution();
            this.initialRadialSumDimProb();
            this.initialPieProbTracking();
        }
    },
})
</script>

<style lang="scss" scoped>
input[type="radio"] {
    display: none;
}

.stacked_77_prov {
    overflow-x: auto;
}

@media screen and (max-width: 1399px) {
    .stacked_77_prov {
        overflow-x: auto;
        max-width: calc(100vw - 200px);
    }
}

@media screen and (max-width: 767.8px) {
    .stacked_77_prov {
        overflow-x: auto;
        max-width: calc(100vw - 180px);
    }
}

@media screen and (max-width: 639.8px) {
    .stacked_77_prov {
        overflow-x: auto;
        max-width: calc(100vw - 150px);
    }
}

#stacked_77_prov_section::-webkit-scrollbar {
    padding-top: 10px;
    height: 5px;
}

#stacked_77_prov_section::-webkit-scrollbar-track {
    background: none;
}

#stacked_77_prov_section::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, .2);
    border-radius: 10px;
    transition: all .2s ease;
}

#stacked_77_prov_section::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, .4);
}

.box-shadow {
    box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
}

.vs__dropdown-toggle {
    background: #FFF;

}

.vs__search {
    font-size: 0.75rem;
}

.card {
    margin-top: 1rem;
    border-radius: 10px;
    padding: 1rem 1.2rem;
    background-color: #f3f6f9;
}
</style>
